module.exports = __webpack_public_path__ + "img/st5.34d18856.png";